import { render } from "./ProductBestSellerSkeleton.vue?vue&type=template&id=0a3caa10&scoped=true"
import script from "./ProductBestSellerSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductBestSellerSkeleton.vue?vue&type=script&lang=js"

import "./ProductBestSellerSkeleton.vue?vue&type=style&index=0&id=0a3caa10&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3caa10"]])

export default __exports__